export const createMeterAssignment = `
    mutation createMeterAssignment($input: CreateMeterAssignmentInput!) {
        createMeterAssignment(input:$input) {
            id
            customerId
            meterId
            sortKey
            channel
            channelIdentifiers
            freeTierQuantity
            committedQuantity
            status
            effectiveFrom
            effectiveTo
            createdByUsername
            createdByUser {
              name
              givenName
              familyName
              email
            }
            created
            updated
    }
}`;

export const updateMeterAssignment = `
    mutation updateMeterAssignment($input: UpdateMeterAssignmentInput!) {
        updateMeterAssignment(input:$input){
            id
            customerId
            meterId
            sortKey
            channel
            channelIdentifiers
            freeTierQuantity
            committedQuantity
            status
            effectiveFrom
            effectiveTo
            createdByUsername
            createdByUser {
              name
              givenName
              familyName
              email
            }
            created
            updated
        }
}`;

// FNP-217: the MeterAssignment table is composite-key (PK customerId, SK
// sortKey). The delete mutation therefore takes { customerId, sortKey }, NOT
// { id } — both are present on every fetched row.
export const deleteMeterAssignment = `
    mutation deleteMeterAssignment($input: DeleteMeterAssignmentInput!) {
        deleteMeterAssignment(input:$input)
}`;
